import { endPoints, requestType } from "../constants/variables";
import Api from "./index";

const callBackRequest = (payload) => {
  return Api(endPoints.callBackRequest, payload, requestType.POST);
};

export { callBackRequest };
